import { render } from "./BirdSound.vue?vue&type=template&id=6064a3c8"
import script from "./BirdSound.vue?vue&type=script&lang=js"
export * from "./BirdSound.vue?vue&type=script&lang=js"

import "./BirdSound.vue?vue&type=style&index=0&id=6064a3c8&lang=css"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__